import { render, staticRenderFns } from "./RegistrationFormAbbr.vue?vue&type=template&id=10ac3e2c&scoped=true&"
import script from "./RegistrationFormAbbr.vue?vue&type=script&lang=js&"
export * from "./RegistrationFormAbbr.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFormAbbr.vue?vue&type=style&index=0&id=10ac3e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac3e2c",
  null
  
)

export default component.exports